import { AutoLinkNode, LinkNode } from "@lexical/link"
import { ListItemNode } from "@lexical/list"
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table"
import { InternalLinkNode } from "admin-lexical/plugins/internal-link/InternalLinkNode"
import { LIST_NODES } from "admin-lexical/plugins/list/StyledListNode"
import { ImageNode } from "./images/ImageNode"
import { HeadingNode, QuoteNode } from "@lexical/rich-text"

export const NODES = [
  HeadingNode,
  LinkNode,
  AutoLinkNode,
  InternalLinkNode,
  TableCellNode,
  TableNode,
  TableRowNode,
  ...LIST_NODES,
  ListItemNode,
  ImageNode,
]
